import React from "react";
import { Theme, useMediaQuery } from "@mui/material";
import Profile from "../pages/Profile";
import HeaderBar from "./HeaderBar";

const ProfileWrapper: React.FC = () => {
  const isSmallScreen = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down("sm"),
  );

  const styles = {
    padding: isSmallScreen ? "1em" : "2em",
    margin: isSmallScreen ? 0 : "auto",
    maxWidth: "800px",
    flex: 1,
  };

  return (
    <div style={styles}>
      <HeaderBar />
      <h2>Profile</h2>
      <Profile />
    </div>
  );
};

export default ProfileWrapper;
